// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-submenu {
  position: relative;
}

::ng-deep.myCustomModalClasscreatexml.modal.show {
  z-index: 1050 !important;
  height: 100vh;
  width: 102vw;
  left: -1.3%;
  top: 3%;
}

::ng-deep.myCustomModalClasscreatexml .modal-dialog {
  max-width: 97%;
  max-height: 60%;
  height: 60%;
  margin: auto;
  padding: 0 !important;
}

::ng-deep .myCustomModalClassCompareVersion.modal.show {
  z-index: 1050 !important;
  height: 86vh;
  width: 88vw;
  left: 12%;
  top: 10%;
}

::ng-deep .myCustomModalClassCompareVersion .modal-dialog {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  height: 100% !important;
}

.dropdown-submenu .dropdown-menu {
  top: 0;
  left: -1%;
  margin-top: 30px;
}

.input_style {
  width: 100%;
  padding-inline: 10px;
  height: 42px;
  margin-block: 5px;
}

.modal-dialog {
  transform: none !important;
}

::ng-deep.cdk-overlay-container {
  isolation: isolate;
  z-index: 1000 !important;
}

::ng-deep.cdk-overlay-container,
.cdk-global-overlay-wrapper,
.cdk-overlay-connected-position-bounding-box {
  isolation: isolate;
  z-index: 9000 !important;
}

.example-tree-progress-bar {
  margin-left: 30px;
}

.example-tree-nested-node {
  padding-left: 30px;
}

mat-tree {
  margin-left: 40px;
}

.mat-tree-node {
  padding: 0;
  background-color: white;
}

.mat-nested-tree-node {
  top: -24px;
}

.mat_treeData ul,
.mat_treeData li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.mat_treeData li.example-tree-container {
  border-bottom: 0;
}
.mat_treeData ul {
  padding-left: 40px;
}
.mat_treeData li {
  padding-left: 40px;
  border: 1px dotted #673ab7;
  border-width: 0 0 1px 2px;
  position: relative;
  top: 0px;
  width: -moz-fit-content;
  width: fit-content;
}
.mat_treeData li.mat-tree-node,
.mat_treeData li div {
  margin: 0;
  position: relative;
}
.mat_treeData li ul {
  border-top: 1px dotted grey;
  margin-left: -40px;
  padding-left: 60px;
}

.mat-nested-tree-node:last-child ul {
  border-left: 1px solid white;
  margin-left: -41px;
}

.mat-icon-button {
  isolation: isolate;
  z-index: 100;
}

::ng-deep.mat-tree-node {
  display: flex;
  align-items: center;
  min-height: 27px !important;
  padding: 0 24px;
  flex: 1;
  overflow: hidden;
  word-wrap: break-word;
}

.mat-raised-button {
  line-height: 22px;
}

.mat-fab.mat-primary,
.mat-mini-fab.mat-primary,
.mat-raised-button.mat-primary {
  color: #fff;
  border-radius: 5pc;
}

.example-tree-invisible {
  display: none;
}

.example-tree ul,
.example-tree li {
  margin-top: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.titleCard {
  width: 20%;
  padding: 10px;
  text-align: center;
  z-index: 9;
  position: relative;
  top: -11px;
  background-color: #17a2b8;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mapping_screen ul,
.mapping_screen li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.mapping_screen li.example-tree-container {
  border-bottom: 0;
}
.mapping_screen ul {
  padding-left: 40px;
}
.mapping_screen li {
  padding-left: 42px;
  border: 1px dotted #2d0375;
  border-width: 0 0 1px 2px;
  position: relative;
  top: 0px;
  width: -moz-fit-content;
  width: fit-content;
}
.mapping_screen li.mat-tree-node,
.mapping_screen li div {
  margin: 0;
  position: relative;
}
.mapping_screen li ul {
  border-top: 1px dotted grey;
  margin-left: -40px;
  padding-left: 60px;
}
.mapping_screen .mat-nested-tree-node:last-child ul {
  border-left: 1px solid white;
  margin-left: -41px;
}
.mapping_screen .btn_mapping {
  background-color: #3a4fb7;
  color: white;
  border-radius: 12px;
  height: 21px;
  font-size: 12px;
  position: relative;
  left: 10px;
  letter-spacing: normal;
}

::ng-deep.mat-menu-content {
  max-height: 350px !important;
}

.expression_controls input {
  height: 32px;
  font-size: 15px;
  padding-bottom: 2%;
  width: 90%;
}

.expression_comment {
  position: relative;
  bottom: 11%;
  width: 100%;
  left: 21px;
}

.highlighter {
  background: gold !important;
  color: black !important;
  border-radius: 20px;
  height: 21px;
  font-size: 12px;
  letter-spacing: normal;
}

.Template_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 1%;
  margin-block: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Template_dropDown .mat-select-trigger {
  min-width: 10vw;
}

.mat_selection {
  margin-left: 4%;
  margin-bottom: 4%;
  height: 35px;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.mat_selection .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.mat-selection_label .mat-form-field-label-wrapper {
  position: absolute !important;
  top: 1px !important;
}

::ng-deep.mat-selection_label .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.selection_label .mat-select-trigger {
  min-width: 10vw;
}

::ng-deep.path_class {
  width: 100%;
}

::ng-deep.path_class .mat-form-field-appearance-outline .mat-form-field-wrapper {
  margin: 0 !important;
  padding: 0 !important;
}

::ng-deep.path_class .mat-form-field-infix {
  height: 33px !important;
  font-size: 13px;
  padding-block: 0% !important;
  margin: 0 !important;
  padding: 0;
}

:ng-deep.mat-form-field-type-mat-select .mat-form-field-label {
  margin: 0 !important;
  top: 7px !important;
}

.mat-select-panel {
  min-width: 0 !important;
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
}

.search_btn {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.paramsWidth {
  width: 100%;
  border-radius: 5px;
  border: 1px solid grey;
  padding-block: 2px;
  padding-left: 2%;
  height: 21px;
  font-size: 12px;
}

.closeparams {
  position: absolute;
  right: -5%;
  font-size: 14px;
  z-index: 9999;
  cursor: pointer;
  top: 62%;
}

.uploadMapping {
  width: 5%;
  opacity: 0 !important;
  position: absolute !important;
  top: 3% !important;
  overflow: hidden !important;
  right: 1% !important;
  left: unset;
}

.dateformatdropdown {
  padding: 1%;
  height: 32px;
  font-size: 15px;
}

::ng-deep.variabel_dropdown {
  width: 100%;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  max-height: 189px !important;
  isolation: isolate;
  z-index: 999999;
}

.variabel_dropdown .dropdown-item:hover,
.dropdown-item:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: #17a2b8;
}

.concat_input {
  height: 24px;
  font-size: 12px;
  top: 22%;
  border-radius: 5px;
  border: 1px solid grey;
}

.route_detailsdropdown {
  width: 100%;
  padding: 1%;
  height: 32px;
  font-size: 15px;
}

.route_detailsoption {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  max-height: 189px !important;
  isolation: isolate;
  z-index: 999999;
}

.hide {
  display: none;
}

.show {
  display: block;
}

.field_drop {
  width: 68%;
  margin-left: 4%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: 3px;
  background-color: white;
  left: -5px;
}

::ng-deep .field_drop .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

::ng-deep .field_drop .mat-form-field-flex {
  padding: 0 !important;
}

.field_droping {
  width: 23%;
  margin-left: 4%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -3px;
  background-color: rgb(255, 255, 255);
  left: -5px;
  height: 32px;
}

::ng-deep .field_droping .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

::ng-deep .field_droping .mat-form-field-flex {
  padding: 0 !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.drop_btn {
  position: absolute;
  right: 2%;
  top: 49%;
  height: 28px !important;
  border: none;
  outline: none !important;
  color: black;
  padding: 0;
  min-width: 29px;
  line-height: 1;
}

.breadcrumb {
  list-style: none;
  overflow: hidden;
  font: 18px Helvetica, Arial, Sans-Serif;
  margin: 40px;
  margin-left: 0;
  padding: 0;
  display: flex;
  flex-wrap: unset;
  overflow-x: auto;
  background-color: transparent;
  max-width: inherit;
}

.breadcrumb li {
  float: left;
}

.breadcrumb li a {
  color: white;
  text-decoration: none;
  padding: 5px 0 5px 55px;
  background: hsl(180, 85%, 35%);
  /* fallback color */
  background: hsl(180, 85%, 35%);
  position: relative;
  display: block;
  float: left;
  font-size: 12px;
}

.breadcrumb li a:after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  border-left: 30px solid hsl(180, 85%, 35%);
  position: absolute;
  top: 50%;
  margin-top: -50px;
  left: 100%;
  z-index: 2;
}

.breadcrumb li a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  border-left: 30px solid white;
  position: absolute;
  top: 50%;
  margin-top: -50px;
  margin-left: 1px;
  left: 100%;
  z-index: 1;
}

.breadcrumb li:first-child a {
  padding-left: 10px;
}

.breadcrumb li:last-child a {
  background: blue !important;
  color: white;
  pointer-events: none;
  cursor: default;
  padding-inline-end: 12px;
}

.breadcrumb li:last-child a:before {
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  border-left: 30px solid blue;
}

.breadcrumb li:last-child a:after {
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  border-left: 30px solid blue;
}

.breadcrumb li a:hover {
  background: hsl(180, 85%, 35%);
}

.breadcrumb li a:hover:after {
  border-left-color: hsl(180, 85%, 35%) !important;
}

.breadcrumb li:last-child a:hover:after {
  border-left-color: blue !important;
}

.steps {
  margin: 40px;
  padding: 0;
  overflow: hidden;
}

.steps a {
  color: white;
  text-decoration: none;
}

.steps em {
  display: block;
  font-size: 1.1em;
  font-weight: bold;
}

.steps li {
  float: left;
  margin-left: 0;
  width: 150px;
  /* 100 / number of steps */
  height: 70px;
  /* total height */
  list-style-type: none;
  padding: 5px 5px 5px 30px;
  /* padding around text, last should include arrow width */
  border-right: 3px solid white;
  /* width: gap between arrows, color: background of document */
  position: relative;
}

/* remove extra padding on the first object since it doesn't have an arrow to the left */
.steps li:first-child {
  padding-left: 5px;
}

/* white arrow to the left to "erase" background (starting from the 2nd object) */
.steps li:nth-child(n+2)::before {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  border-left: 25px solid white;
  /* width: arrow width, color: background of document */
  border-top: 40px solid transparent;
  /* width: half height */
  border-bottom: 40px solid transparent;
  /* width: half height */
  width: 0;
  height: 0;
  content: " ";
}

/* colored arrow to the right */
.steps li::after {
  z-index: 1;
  /* need to bring this above the next item */
  position: absolute;
  top: 0;
  right: -25px;
  /* arrow width (negated) */
  display: block;
  border-left: 25px solid #7c8437;
  /* width: arrow width */
  border-top: 40px solid transparent;
  /* width: half height */
  border-bottom: 40px solid transparent;
  /* width: half height */
  width: 0;
  height: 0;
  content: " ";
}

/* Setup colors (both the background and the arrow) */
/* Completed */
.steps li {
  background-color: #7C8437;
}

.steps li::after {
  border-left-color: #7c8437;
}

/* Current */
.steps li.current {
  background-color: #C36615;
}

.steps li.current::after {
  border-left-color: #C36615;
}

/* Following */
.steps li.current ~ li {
  background-color: #EBEBEB;
}

.steps li.current ~ li::after {
  border-left-color: #EBEBEB;
}

/* Hover for completed and current */
.steps li:hover {
  background-color: #696;
}

.steps li:hover::after {
  border-left-color: #696;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: auto !important;
  }
}
::ng-deep .mat-expansion-panel-header {
  height: 42px !important;
}

.mat_dynamicJson_select {
  display: block;
  height: 24px !important;
  border: 1px solid grey;
  border-radius: 5px;
  padding-left: 2%;
}
.mat_dynamicJson_select ::ng-deep.mat-form-field-infix {
  padding-top: 3px !important;
  top: 3px;
}
.mat_dynamicJson_select ::ng-deep .mat-select-arrow {
  color: black !important;
}

.close_mapping {
  float: right;
  position: relative;
  bottom: 2%;
  background-color: #17a2b8;
  color: white;
  width: -moz-fit-content;
  width: fit-content;
  margin-block: 1%;
  right: 5%;
}

.close_mappinggloble {
  float: right;
  position: relative;
  background-color: #17a2b8;
  color: white;
  width: -moz-fit-content;
  width: fit-content;
  margin-block: 1%;
  right: 8%;
}

.suggest_btn {
  height: 29px;
  line-height: inherit;
  font-size: 12px !important;
}

.suggest_btn:hover {
  color: blue;
}

.isChildStyle {
  background-color: blue;
  color: white;
}

::ng-deep.addComment.mat-menu-panel {
  transform-origin: right top;
  max-width: 480px !important;
  min-width: 335px !important;
  min-height: auto !important;
}
::ng-deep.addComment.mat-menu-panel button.mat-menu-item {
  min-height: 112px !important;
}

.btn_icon {
  margin-top: -9px;
  padding-block: 0px;
  height: 28px !important;
}

.font_size {
  font-size: 12px !important;
}

.pipeline_title {
  color: #0c0c0c;
  text-align: initial;
  font-size: 12px !important;
  font-weight: 700;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
  transform: none !important;
  margin-top: 22px;
}

.myPanelClass {
  margin-top: 30px !important;
}

.templateAdd_input {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  margin-left: -14%;
}

._curspointer {
  cursor: pointer;
}

.text-ellipsis {
  max-width: 83%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.versionnotes.mat-dialog {
  width: 85% !important;
  top: 10% !important;
}

.versionnotes.modal-content {
  height: 380px !important;
}

.svg_userrole {
  font-size: 17px;
  position: relative;
  top: 3px;
  width: auto;
  left: -2px;
  color: #307de1;
}

::ng-deep.Version_dropDown .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value {
  width: 65% !important;
}

.Version_dropDown {
  height: 32px;
  border-radius: 5px;
  position: relative;
  top: 1%;
  background-color: white;
  margin-block: 1%;
  padding-left: 5px;
}

::ng-deep.Version_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Version_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Version_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Version_dropDown .mat-select-trigger {
  min-width: 8vw !important;
}

::ng-deep.Version_dropDown .mat-select-arrow {
  position: absolute !important;
  right: 5% !important;
}

::ng-deep.mappingnote .modal-dialog {
  max-width: 83% !important;
  top: 10% !important;
  max-height: 60% !important;
  height: 52% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.mappingnote .modal-backdrop.show {
  z-index: 1050 !important;
}

::ng-deep.mapping_method_auto .autocomplete-container .suggestions-container.is-visible {
  z-index: 999 !important;
  border-radius: 5px !important;
  bottom: 100% !important;
}

.others_width {
  width: 581px !important;
  position: relative !important;
}

.primary_btn {
  background-color: #673ab7 !important;
  color: #fff !important;
  letter-spacing: normal !important;
  border-radius: 5pc;
}

.mapped_btn {
  background-color: #05640d !important;
  color: #fff !important;
  border-radius: 5pc;
  letter-spacing: normal !important;
}

::ng-deep.matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

::ng-deep body.xmlmappings-version-select-open .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none !important;
}

::ng-deep .mat-mdc-select-panel.xmlmappings-version-select-panel {
  z-index: 10001 !important;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.custom-drag-preview {
  z-index: 100000000000 !important;
  opacity: 0.9 !important;
  border-radius: 5pc;
}

.xml-split-toggle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: calc(50% - 12px);
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  border-radius: 5%;
  width: 20px;
  height: 20px;
  line-height: 36px;
  background-color: #a9a9a9;
}
.xml-split-toggle.xml-split-toggle--edge {
  left: 8px;
}
.xml-split-toggle mat-icon {
  right: 12px;
  font-size: 22px;
  position: relative;
  bottom: 16px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/xmlmappings/xmlmappings.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;AAAJ;;AAGE;EACE,wBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;AAAJ;;AAEE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AACJ;;AAEE;EACE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AACJ;;AACE;EACE,0BAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;AAEJ;;AACE;EACE,MAAA;EACA,SAAA;EACA,gBAAA;AAEJ;;AAAE;EACE,WAAA;EACA,oBAAA;EACA,YAAA;EACA,iBAAA;AAGJ;;AAaA;EACE,0BAAA;AAVF;;AAaA;EACE,kBAAA;EACA,wBAAA;AAVF;;AAaA;;;EAGE,kBAAA;EACA,wBAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaE;EACE,kBAAA;AAVJ;;AAaE;EACE,iBAAA;AAVJ;;AAYE;EACE,UAAA;EACA,uBAAA;AATJ;;AAaA;EACE,UAAA;AAVF;;AAeE;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;AAZJ;AAeE;EACE,gBAAA;AAbJ;AAgBE;EACE,kBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EAAA,kBAAA;AAfJ;AAkBE;;EAEE,SAAA;EACA,kBAAA;AAhBJ;AAoBE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AAlBJ;;AAuBE;EACE,4BAAA;EACA,kBAAA;AApBJ;;AAuBE;EACE,kBAAA;EACA,YAAA;AApBJ;;AAuBE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,OAAA;EACA,gBAAA;EACA,qBAAA;AApBJ;;AAuBE;EACE,iBAAA;AApBJ;;AAuBA;;;EAGE,WAAA;EACA,kBAAA;AApBF;;AAuBE;EACE,aAAA;AApBJ;;AAuBE;;EAEA,aAAA;EACA,gBAAA;EACA,qBAAA;AApBF;;AAuBA;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACJ,gBAAA;EACA,uBAAA;AApBA;;AAyBE;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;AAtBJ;AAyBE;EACE,gBAAA;AAvBJ;AA0BE;EACE,kBAAA;AAxBJ;AA2BE;EACE,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EAAA,kBAAA;AAzBJ;AA4BE;;EAEE,SAAA;EACA,kBAAA;AA1BJ;AA8BE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AA5BJ;AA+BE;EACE,4BAAA;EACA,kBAAA;AA7BJ;AAgCE;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AA9BJ;;AAiCA;EACE,4BAAA;AA9BF;;AA0CA;EACE,YAAA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAvCJ;;AA0CA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AAvCJ;;AAmEA;EACE,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AAhEF;;AAiFA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA9EF;;AAgFA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AA7EF;;AA+EA;EACE,WAAA;EACA,UAAA;AA5EF;;AA8EA;EACE,oBAAA;AA3EF;;AA6EA;EACE,eAAA;AA1EF;;AA6EA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA5EF;;AA8EA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AA3EF;;AA6EA;EACE,WAAA;EACA,UAAA;AA1EF;;AA4EA;EACE,6BAAA;EACA,mBAAA;AAzEF;;AA2EA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAxEF;;AA0EA;EACE,WAAA;EACA,UAAA;AAvEF;;AA0EA;EACE,eAAA;AAvEF;;AAyEA;EACI,WAAA;AAtEJ;;AAyEA;EACE,oBAAA;EACA,qBAAA;AAtEF;;AAwEA;EACE,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,oBAAA;EACA,UAAA;AArEF;;AAmFA;EACE,oBAAA;EACE,mBAAA;AAhFJ;;AA4FA;EACE,uBAAA;EACA,sCAAA;EAAA,iCAAA;AAzFF;;AA4FA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AAzFF;;AA6FA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AA1FF;;AA8FA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AA3FF;;AA8FA;EACE,SAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,WAAA;AA3FF;;AA6FA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA1FF;;AA6FA;EACE,WAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;AA1FF;;AA6FA;;EAEE,cAAA;EACA,qBAAA;EACA,yBAAA;AA1FF;;AA4FA;EACE,YAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,sBAAA;AAzFF;;AA2FA;EACE,WAAA;EAEA,WAAA;EACA,YAAA;EACA,eAAA;AAzFF;;AA4FA;EACE,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;AAzFF;;AA2FA;EACE,aAAA;AAxFF;;AA0FA;EACE,cAAA;AAvFF;;AA2FA;EACE,UAAA;EACA,eAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,UAAA;AAxFF;;AA2FA;EACE,4BAAA;AAxFF;;AA0FA;EACE,qBAAA;AAvFF;;AA4FA;EACE,UAAA;EACA,eAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AAzFF;;AA4FA;EACE,4BAAA;AAzFF;;AA2FA;EACE,qBAAA;AAxFF;;AA0FA;EACE,sBAAA;AAvFF;;AA0FA;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAvFF;;AA0FA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBCzjBU;ED0jBV,YAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AAvFF;;AA4FA;EACE,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;AAzFF;;AA4FA;EACE,WAAA;AAzFF;;AA4FA;EACE,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAzFF;;AA4FA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,8CAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;AAzFF;;AA4FA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,8CAAA;EACA,qCAAA;EACA,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAzFF;;AA4FA;EACE,kBAAA;AAzFF;;AA4FA;EACE,2BAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AAzFF;;AA4FA;EACE,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,8CAAA;EACA,qCAAA;EACA,4BAAA;AAzFF;;AA4FA;EACE,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,8CAAA;EACA,qCAAA;EACA,4BAAA;AAzFF;;AA4FA;EACE,8BAAA;AAzFF;;AA4FA;EACE,gDAAA;AAzFF;;AA4FA;EACE,kCAAA;AAzFF;;AA4FA;EACE,YAAA;EACA,UAAA;EACA,gBAAA;AAzFF;;AA4FA;EACE,YAAA;EACA,qBAAA;AAzFF;;AA4FA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AAzFF;;AA4FA;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yDAAA;EACA,6BAAA;EACA,6DAAA;EACA,kBAAA;AAzFF;;AA4FA,wFAAA;AACA;EACE,iBAAA;AAzFF;;AA4FA,iFAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,6BAAA;EACA,sDAAA;EACA,kCAAA;EACA,uBAAA;EACA,qCAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAzFF;;AA4FA,+BAAA;AACA;EACE,UAAA;EACA,2CAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,0BAAA;EACA,cAAA;EACA,+BAAA;EACA,uBAAA;EACA,kCAAA;EACA,uBAAA;EACA,qCAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAzFF;;AA4FA,qDAAA;AAEA,cAAA;AACA;EACE,yBAAA;AA1FF;;AA6FA;EACE,0BAAA;AA1FF;;AA6FA,YAAA;AACA;EACE,yBAAA;AA1FF;;AA6FA;EACE,0BAAA;AA1FF;;AA6FA,cAAA;AACA;EACE,yBAAA;AA1FF;;AA6FA;EACE,0BAAA;AA1FF;;AA6FA,oCAAA;AACA;EACE,sBAAA;AA1FF;;AA6FA;EACE,uBAAA;AA1FF;;AA8FA;EACE;IACE,gBAAA;IACA,uBAAA;EA3FF;AACF;AA8FA;EACE,uBAAA;AA5FF;;AAgGA;EACE,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA7FF;AA8FE;EACE,2BAAA;EACA,QAAA;AA5FJ;AA8FC;EACG,uBAAA;AA5FJ;;AAgGA;EACE,YAAA;EAAa,kBAAA;EAAmB,UAAA;EAAW,yBAAA;EAA0B,YAAA;EAAa,uBAAA;EAAA,kBAAA;EAAmB,gBAAA;EAAgB,SAAA;AAtFvH;;AAyFA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,SAAA;AAtFF;;AAyFA;EACE,YAAA;EACA,oBAAA;EACA,0BC/0BS;ADyvBX;;AAwFA;EACA,WAAA;AArFA;;AAuFA;EACE,sBAAA;EACA,YAAA;AApFF;;AA6FC;EACC,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AA1FF;AA4FE;EACE,4BAAA;AA1FJ;;AA+FA;EACE,gBAAA;EACA,kBAAA;EACA,uBC52BU;ADgxBZ;;AA8FA;EACE,0BCj3BS;ADsxBX;;AA8FA;EACE,cAAA;EAAe,mBAAA;EAAmB,0BCr3BzB;EDq3B6C,gBAAA;AAxFxD;;AA2FA;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AAxFF;;AA2FA;EACE,2BAAA;AAxFF;;AA2FA;EACA,uBCt4Ba;EDu4Bb,0BC14BW;ED24BX,oDAAA;EACA,iBAAA;AAxFA;;AA2FA;EACE,eAAA;AAxFF;;AA0FA;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvFJ;;AAyFA;EACI,qBAAA;EACA,mBAAA;AAtFJ;;AAwFA;EACE,wBAAA;AArFF;;AAwFA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;AArFF;;AAuFA;EACE,qBAAA;AApFF;;AAsFA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAnFF;;AAqFA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAlFF;;AAoFA;EACE,WAAA;EACA,UAAA;AAjFF;;AAmFA;EACE,oBAAA;AAhFF;;AAkFA;EACE,yBAAA;AA/EF;;AAiFA;EACE,6BAAA;EACA,oBAAA;AA9EF;;AAgFA;EACE,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA7EF;;AA+EA;EACE,wBAAA;AA5EF;;AA+EA;EACE,uBAAA;EACA,6BAAA;EACA,uBAAA;AA5EF;;AA+EA;EACE,uBAAA;EACA,6BAAA;AA5EF;;AAgFA;EACE,oCAAA;EACA,sBAAA;EACA,iCAAA;EACE,kBAAA;AA7EJ;;AA+EA;EACE,oCAAA;EACA,sBAAA;EACE,kBAAA;EACA,iCAAA;AA5EJ;;AA8EA;EACE,2BAAA;EACA,8BAAA;AA3EF;;AA8EA;EAEE,+BAAA;AA5EF;;AA+EA;EACE,yBAAA;AA5EF;;AAmFA;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AAhFF;;AAqFA;EACE,UAAA;AAlFF;;AAqFA;EACE,sDAAA;AAlFF;;AA4FA;EACA,gCAAA;EACA,uBAAA;EACA,kBAAA;AAzFA;;AA4FA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AAzFF;AA2FE;EACE,SAAA;AAzFJ;AA4FE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AA1FJ","sourcesContent":["@import '../../variables.scss';\r\n.dropdown-submenu {\r\n    position:relative;\r\n\r\n  }\r\n  ::ng-deep.myCustomModalClasscreatexml.modal.show {\r\n    z-index: 1050 !important;\r\n    height: 100vh;\r\n    width: 102vw;\r\n    left: -1.3%;\r\n    top: 3%;\r\n  }\r\n  ::ng-deep.myCustomModalClasscreatexml .modal-dialog {\r\n    max-width: 97%;\r\n    max-height: 60%;\r\n    height: 60%;\r\n    margin: auto;\r\n    padding: 0 !important;\r\n  }\r\n\r\n  ::ng-deep .myCustomModalClassCompareVersion.modal.show {\r\n    z-index: 1050 !important;\r\n    height: 86vh;\r\n    width: 88vw;\r\n    left: 12%;\r\n    top: 10%;\r\n  }\r\n  ::ng-deep .myCustomModalClassCompareVersion .modal-dialog {\r\n    max-width: 100% !important;\r\n    width: 100% !important;\r\n    margin: 0 !important;\r\n    height: 100% !important;\r\n  }\r\n\r\n  .dropdown-submenu .dropdown-menu {\r\n    top: 0;\r\n    left: -1%;\r\n    margin-top: 30px;\r\n  }\r\n  .input_style {\r\n    width: 100%;\r\n    padding-inline: 10px;\r\n    height: 42px;\r\n    margin-block: 5px;\r\n  }\r\n\r\n  // ::ng-deep.autocomplete-container .input-container input{\r\n  //   border-radius: 5px !important;\r\n  //   padding-right: 13% !important;\r\n  //   height: 31px !important;\r\n  // }\r\n  // ::ng-deep.autocomplete-container {\r\n  //   box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  //   position: relative;\r\n  //   overflow: visible;\r\n  //   height: 31px !important;\r\n  //   border-radius: 5px;\r\n  // }\r\n\r\n.modal-dialog {\r\n  transform: none !important;\r\n}\r\n\r\n::ng-deep.cdk-overlay-container {\r\n  isolation: isolate;\r\n  z-index: 1000 !important;\r\n}\r\n\r\n::ng-deep.cdk-overlay-container,\r\n.cdk-global-overlay-wrapper,\r\n.cdk-overlay-connected-position-bounding-box {\r\n  isolation: isolate;\r\n  z-index: 9000 !important;\r\n}\r\n\r\n.example-tree-progress-bar {\r\n  margin-left: 30px;\r\n}\r\n\r\n  .example-tree-nested-node {\r\n    padding-left: 30px;\r\n  }\r\n\r\n  mat-tree {\r\n    margin-left: 40px;\r\n  }\r\n  .mat-tree-node {\r\n    padding: 0;\r\n    background-color: white;\r\n\r\n  }\r\n\r\n.mat-nested-tree-node {\r\n  top: -24px;\r\n}\r\n\r\n.mat_treeData {\r\n\r\n  ul,\r\n  li {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  li.example-tree-container {\r\n    border-bottom: 0;\r\n  }\r\n\r\n  ul {\r\n    padding-left: 40px;\r\n  }\r\n\r\n  li {\r\n    padding-left: 40px;\r\n    border: 1px dotted #673ab7;\r\n    border-width: 0 0 1px 2px;\r\n    position: relative;\r\n    top: 0px;\r\n    width: fit-content;\r\n  }\r\n\r\n  li.mat-tree-node,\r\n  li div {\r\n    margin: 0;\r\n    position: relative;\r\n    // top: 24px;\r\n  }\r\n\r\n  li ul {\r\n    border-top: 1px dotted grey;\r\n    margin-left: -40px;\r\n    padding-left: 60px;\r\n  }\r\n}\r\n\r\n\r\n  .mat-nested-tree-node:last-child ul {\r\n    border-left: 1px solid white;\r\n    margin-left: -41px;\r\n  }\r\n\r\n  .mat-icon-button {\r\n    isolation: isolate;\r\n    z-index: 100;\r\n  }\r\n\r\n  ::ng-deep.mat-tree-node {\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: 27px !important;\r\n    padding: 0 24px;\r\n    flex: 1;\r\n    overflow: hidden;\r\n    word-wrap: break-word;\r\n  }\r\n\r\n  .mat-raised-button{\r\n    line-height: 22px;\r\n  }\r\n\r\n.mat-fab.mat-primary,\r\n.mat-mini-fab.mat-primary,\r\n.mat-raised-button.mat-primary {\r\n  color: #fff;\r\n  border-radius: 5pc;\r\n}\r\n\r\n  .example-tree-invisible {\r\n    display: none;\r\n  }\r\n\r\n  .example-tree ul,\r\n.example-tree li {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  list-style-type: none;\r\n}\r\n\r\n.titleCard{\r\n    width: 20%;\r\n    padding: 10px;\r\n    text-align: center;\r\n    z-index: 9;\r\n    position: relative;\r\n    top: -11px;\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    white-space: nowrap;\r\noverflow: hidden;\r\ntext-overflow: ellipsis;\r\n}\r\n\r\n\r\n.mapping_screen{\r\n  ul,\r\n  li {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  li.example-tree-container {\r\n    border-bottom: 0;\r\n  }\r\n\r\n  ul {\r\n    padding-left: 40px;\r\n  }\r\n\r\n  li {\r\n    padding-left: 42px;\r\n    border: 1px dotted #2d0375;\r\n    border-width: 0 0 1px 2px;\r\n    position: relative;\r\n    top: 0px;\r\n    width: fit-content;\r\n  }\r\n\r\n  li.mat-tree-node,\r\n  li div {\r\n    margin: 0;\r\n    position: relative;\r\n    // top: 24px;\r\n  }\r\n\r\n  li ul {\r\n    border-top: 1px dotted grey;\r\n    margin-left: -40px;\r\n    padding-left: 60px;\r\n  }\r\n\r\n  .mat-nested-tree-node:last-child ul {\r\n    border-left: 1px solid white;\r\n    margin-left: -41px;\r\n  }\r\n\r\n  .btn_mapping{\r\n    background-color: #3a4fb7;\r\n    color: white;\r\n    border-radius: 12px;\r\n    height: 21px;\r\n    font-size: 12px;\r\n    position: relative;\r\n    left: 10px;\r\n    letter-spacing: normal;\r\n  }\r\n}\r\n::ng-deep.mat-menu-content{\r\n  max-height: 350px !important;\r\n}\r\n\r\n\r\n\r\n// .field_drop{\r\n//   width: 69%;padding-left: 6%;\r\n//   ::ng-deep.mat-form-field-flex{\r\n//   padding-top: 0 !important;\r\n//   }\r\n// }\r\n\r\n.expression_controls input{\r\n  height: 32px;\r\n    font-size: 15px;\r\n    padding-bottom: 2%;\r\n    width: 90%;\r\n}\r\n\r\n.expression_comment{\r\n    position: relative;\r\n    bottom: 11%;\r\n    width: 100%;\r\n    left: 21px;\r\n}\r\n\r\n\r\n// .messagetype_feild {\r\n//   margin-left: 4%;\r\n//   height: 35px;\r\n//   box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n//   border-radius: 5px;\r\n//   padding-inline: 1%;\r\n//   padding-bottom: 1%;\r\n// }\r\n\r\n// ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper{\r\n//   // margin-top: -9% !important;\r\n//   margin-left: 6% !important;\r\n//   padding-bottom: 10% !important;\r\n// }\r\n// ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n//   top: 0;\r\n//   height: 0px !important;\r\n//   overflow: hidden;\r\n// }\r\n// ::ng-deep.mat-form-field-appearance-standard .mat-form-field-underline{\r\n//   height: 0px !important;\r\n// }\r\n\r\n\r\n.highlighter{\r\n  background: gold !important;\r\n  color: black !important;\r\n  border-radius: 20px;\r\n  height: 21px;\r\n  font-size: 12px;\r\n  letter-spacing: normal;\r\n}\r\n\r\n\r\n// .mat_selection {\r\n//   height: 35px !important;\r\n//     padding: 0 !important;\r\n//     margin: 0 !important;\r\n//     border-top: 2px solid transparent;\r\n// }\r\n// .mat_selection{\r\n//   ::ng-deep.mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n//     margin: 0;\r\n//     padding: 0;\r\n//   }\r\n// }\r\n\r\n.Template_dropDown{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 1%;\r\n  margin-block: 1%;\r\n}\r\n::ng-deep.Template_dropDown  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Template_dropDown  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n\r\n.mat_selection{\r\n  // width: 62%;\r\n  margin-left: 4%;\r\n  margin-bottom: 4%;\r\n  height: 35px;\r\n  // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n::ng-deep.mat_selection  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.mat-selection_label .mat-form-field-label-wrapper{\r\n  position: absolute !important;\r\n  top: 1px !important;\r\n}\r\n::ng-deep.mat-selection_label  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n::ng-deep.selection_label  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n::ng-deep.path_class{\r\n    width: 100%;\r\n    // margin-top: 1%;\r\n}\r\n::ng-deep.path_class .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.path_class  .mat-form-field-infix{\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n  padding-block: 0% !important;\r\n  margin: 0 !important;\r\n  padding: 0;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n// ::ng-deep.mat-form-field-appearance-legacy.mat-form-field-wrapper{\r\n//   padding-bottom: 0!important;\r\n// }\r\n// ::ng-deep.mat-form-field-wrapper{\r\n//   padding-bottom: 0!important;\r\n// }\r\n\r\n:ng-deep.mat-form-field-type-mat-select .mat-form-field-label{\r\n  margin: 0 !important;\r\n    top: 7px !important;\r\n}\r\n// ::ng-deep .mat_selection  .mat-select-trigger {\r\n//   min-width: 10vw;\r\n// }\r\n// ::ng-deep  .mat_selection .mat-select-panel {\r\n//   max-height: 10vh !important;\r\n//}\r\n// .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n//   padding-bottom: 0% !important;\r\n// }\r\n\r\n.mat-select-panel {\r\n  min-width: 0 !important;\r\n  max-width: fit-content !important;\r\n}\r\n\r\n.search_btn {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n\r\n.paramsWidth {\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  border: 1px solid grey;\r\n  padding-block: 2px;\r\n  padding-left: 2%;\r\n  height: 21px;\r\n  font-size: 12px;\r\n}\r\n\r\n\r\n.closeparams {\r\n  position: absolute;\r\n  right: -5%;\r\n  font-size: 14px;\r\n  z-index: 9999;\r\n  cursor: pointer;\r\n  top: 62%;\r\n}\r\n\r\n.uploadMapping {\r\n  width: 5%;\r\n  opacity: 0 !important;\r\n  position: absolute !important;\r\n  top: 3% !important;\r\n  overflow: hidden !important;\r\n  right: 1% !important;\r\n  left: unset;\r\n}\r\n.dateformatdropdown{\r\n  padding: 1%;\r\n  height: 32px;\r\n  font-size: 15px;\r\n}\r\n\r\n::ng-deep.variabel_dropdown {\r\n  width: 100%;\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  max-height: 189px !important;\r\n  isolation: isolate;\r\n  z-index: 999999;\r\n}\r\n\r\n.variabel_dropdown .dropdown-item:hover,\r\n.dropdown-item:focus {\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  background-color: #17a2b8;\r\n}\r\n.concat_input{\r\n  height: 24px;\r\n  font-size: 12px;\r\n  top: 22%;\r\n  border-radius: 5px;\r\n  border: 1px solid grey;\r\n}\r\n.route_detailsdropdown {\r\n  width: 100%;\r\n  ;\r\n  padding: 1%;\r\n  height: 32px;\r\n  font-size: 15px;\r\n}\r\n\r\n.route_detailsoption {\r\n  overflow-x: hidden !important;\r\n  overflow-y: auto !important;\r\n  max-height: 189px !important;\r\n  isolation: isolate;\r\n  z-index: 999999\r\n}\r\n.hide{\r\n  display: none;\r\n}\r\n.show{\r\n  display: block;\r\n}\r\n\r\n\r\n.field_drop {\r\n  width: 68%;\r\n  margin-left: 4%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  top: 3px;\r\n  background-color: white;\r\n  left: -5px;\r\n}\r\n\r\n::ng-deep .field_drop .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n::ng-deep .field_drop .mat-form-field-flex {\r\n  padding: 0 !important;\r\n}\r\n\r\n\r\n\r\n.field_droping {\r\n  width: 23%;\r\n  margin-left: 4%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  top: -3px;\r\n  background-color: rgb(255, 255, 255);\r\n  left: -5px;\r\n  height: 32px;\r\n}\r\n\r\n::ng-deep .field_droping .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n::ng-deep .field_droping .mat-form-field-flex {\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n  height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n  top: 0;\r\n  height: 0px !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.drop_btn {\r\n  position: absolute;\r\n  right: 2%;\r\n  top: 49%;\r\n  height: $btnHeight;\r\n  border: none;\r\n  outline: none !important;\r\n  color: black;\r\n  padding: 0;\r\n  min-width: 29px;\r\n  line-height: 1;\r\n}\r\n\r\n\r\n\r\n.breadcrumb {\r\n  list-style: none;\r\n  overflow: hidden;\r\n  font: 18px Helvetica, Arial, Sans-Serif;\r\n  margin: 40px;\r\n  margin-left: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-wrap: unset;\r\n  overflow-x: auto;\r\n  background-color: transparent;\r\n  max-width: inherit;\r\n}\r\n\r\n.breadcrumb li {\r\n  float: left;\r\n}\r\n\r\n.breadcrumb li a {\r\n  color: white;\r\n  text-decoration: none;\r\n  padding: 5px 0 5px 55px;\r\n  background: hsl(180deg 85% 35%);\r\n  /* fallback color */\r\n  background: hsl(180deg 85% 35%);\r\n  position: relative;\r\n  display: block;\r\n  float: left;\r\n  font-size: 12px;\r\n}\r\n\r\n.breadcrumb li a:after {\r\n  content: \" \";\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 50px solid transparent;\r\n  /* Go big on the size, and let overflow hide */\r\n  border-bottom: 50px solid transparent;\r\n  border-left: 30px solid hsl(180deg 85% 35%);\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -50px;\r\n  left: 100%;\r\n  z-index: 2;\r\n}\r\n\r\n.breadcrumb li a:before {\r\n  content: \" \";\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 50px solid transparent;\r\n  /* Go big on the size, and let overflow hide */\r\n  border-bottom: 50px solid transparent;\r\n  border-left: 30px solid white;\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -50px;\r\n  margin-left: 1px;\r\n  left: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.breadcrumb li:first-child a {\r\n  padding-left: 10px;\r\n}\r\n\r\n.breadcrumb li:last-child a {\r\n  background: blue !important;\r\n  color: white;\r\n  pointer-events: none;\r\n  cursor: default;\r\n  padding-inline-end: 12px;\r\n}\r\n\r\n.breadcrumb li:last-child a:before {\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 50px solid transparent;\r\n  /* Go big on the size, and let overflow hide */\r\n  border-bottom: 50px solid transparent;\r\n  border-left: 30px solid blue;\r\n}\r\n\r\n.breadcrumb li:last-child a:after {\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 50px solid transparent;\r\n  /* Go big on the size, and let overflow hide */\r\n  border-bottom: 50px solid transparent;\r\n  border-left: 30px solid blue;\r\n}\r\n\r\n.breadcrumb li a:hover {\r\n  background: hsl(180deg 85% 35%)\r\n}\r\n\r\n.breadcrumb li a:hover:after {\r\n  border-left-color: hsl(180deg 85% 35%) !important;\r\n}\r\n\r\n.breadcrumb li:last-child a:hover:after {\r\n  border-left-color: blue !important;\r\n}\r\n\r\n.steps {\r\n  margin: 40px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.steps a {\r\n  color: white;\r\n  text-decoration: none;\r\n}\r\n\r\n.steps em {\r\n  display: block;\r\n  font-size: 1.1em;\r\n  font-weight: bold;\r\n}\r\n\r\n.steps li {\r\n  float: left;\r\n  margin-left: 0;\r\n  width: 150px;\r\n  /* 100 / number of steps */\r\n  height: 70px;\r\n  /* total height */\r\n  list-style-type: none;\r\n  padding: 5px 5px 5px 30px;\r\n  /* padding around text, last should include arrow width */\r\n  border-right: 3px solid white;\r\n  /* width: gap between arrows, color: background of document */\r\n  position: relative;\r\n}\r\n\r\n/* remove extra padding on the first object since it doesn't have an arrow to the left */\r\n.steps li:first-child {\r\n  padding-left: 5px;\r\n}\r\n\r\n/* white arrow to the left to \"erase\" background (starting from the 2nd object) */\r\n.steps li:nth-child(n+2)::before {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  display: block;\r\n  border-left: 25px solid white;\r\n  /* width: arrow width, color: background of document */\r\n  border-top: 40px solid transparent;\r\n  /* width: half height */\r\n  border-bottom: 40px solid transparent;\r\n  /* width: half height */\r\n  width: 0;\r\n  height: 0;\r\n  content: \" \";\r\n}\r\n\r\n/* colored arrow to the right */\r\n.steps li::after {\r\n  z-index: 1;\r\n  /* need to bring this above the next item */\r\n  position: absolute;\r\n  top: 0;\r\n  right: -25px;\r\n  /* arrow width (negated) */\r\n  display: block;\r\n  border-left: 25px solid #7c8437;\r\n  /* width: arrow width */\r\n  border-top: 40px solid transparent;\r\n  /* width: half height */\r\n  border-bottom: 40px solid transparent;\r\n  /* width: half height */\r\n  width: 0;\r\n  height: 0;\r\n  content: \" \";\r\n}\r\n\r\n/* Setup colors (both the background and the arrow) */\r\n\r\n/* Completed */\r\n.steps li {\r\n  background-color: #7C8437;\r\n}\r\n\r\n.steps li::after {\r\n  border-left-color: #7c8437;\r\n}\r\n\r\n/* Current */\r\n.steps li.current {\r\n  background-color: #C36615;\r\n}\r\n\r\n.steps li.current::after {\r\n  border-left-color: #C36615;\r\n}\r\n\r\n/* Following */\r\n.steps li.current~li {\r\n  background-color: #EBEBEB;\r\n}\r\n\r\n.steps li.current~li::after {\r\n  border-left-color: #EBEBEB;\r\n}\r\n\r\n/* Hover for completed and current */\r\n.steps li:hover {\r\n  background-color: #696\r\n}\r\n\r\n.steps li:hover::after {\r\n  border-left-color: #696\r\n}\r\n\r\n\r\n@media (min-width: 576px) {\r\n  .modal-dialog {\r\n    max-width: 500px;\r\n    margin: auto !important;\r\n  }\r\n}\r\n\r\n::ng-deep .mat-expansion-panel-header {\r\n  height: 42px !important;\r\n}\r\n\r\n\r\n.mat_dynamicJson_select {\r\n  display: block;\r\n  height: 24px !important;\r\n  border: 1px solid grey;\r\n  border-radius: 5px;\r\n  padding-left: 2%;\r\n  ::ng-deep.mat-form-field-infix {\r\n    padding-top: 3px !important;\r\n    top:3px;\r\n  }\r\n ::ng-deep .mat-select-arrow {\r\n    color: black !important;\r\n}\r\n}\r\n\r\n.close_mapping{\r\n  float: right;position: relative;bottom: 2%;background-color: #17a2b8;color: white;width: fit-content;margin-block:1%;right: 5%;\r\n}\r\n\r\n.close_mappinggloble{\r\n  float: right;\r\n  position: relative;\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  width: fit-content;\r\n  margin-block: 1%;\r\n  right: 8%;\r\n}\r\n\r\n.suggest_btn{\r\n  height: 29px;\r\n  line-height: inherit;\r\n  font-size: $fontsize;\r\n}\r\n.suggest_btn:hover{\r\ncolor: blue;\r\n}\r\n.isChildStyle{\r\n  background-color:blue;\r\n  color: white;\r\n  // height:20px;\r\n}\r\n\r\n// .custom__menu + * .cdk-overlay-pane > div.mat-menu-panel > div.mat-menu-content {\r\n// z-index: 11;\r\n//  }\r\n\r\n\r\n ::ng-deep.addComment.mat-menu-panel {\r\n  transform-origin: right top;\r\n  max-width: 480px !important;\r\n  min-width: 335px !important;\r\n  min-height: auto !important;\r\n\r\n  button.mat-menu-item {\r\n    min-height: 112px !important;\r\n  }\r\n}\r\n\r\n\r\n.btn_icon{\r\n  margin-top: -9px;\r\n  padding-block: 0px;\r\n  height:$btnHeight;\r\n}\r\n.font_size{\r\n  font-size:$fontsize;\r\n}\r\n\r\n.pipeline_title{\r\n  color: #0c0c0c;text-align:initial;font-size:$fontsize;font-weight: 700;\r\n}\r\n\r\n.cdk-overlay-pane  {\r\n  position:absolute;\r\n  pointer-events:auto;\r\n  box-sizing:border-box;\r\n  z-index:1000;\r\n  display:flex;\r\n  max-width:100%;\r\n  max-height:100%;\r\n  transform:none !important;\r\n  margin-top:22px;\r\n}\r\n\r\n.myPanelClass{\r\n  margin-top: 30px !important;\r\n}\r\n\r\n.templateAdd_input{\r\nheight:$inputHeight;\r\nfont-size:$fontsize;\r\nbox-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\nmargin-left: -14%;\r\n}\r\n\r\n._curspointer{\r\n  cursor: pointer;\r\n}\r\n.text-ellipsis{\r\n    max-width: 83%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n.versionnotes.mat-dialog{\r\n    width: 85%!important;\r\n    top:10%!important;\r\n}\r\n.versionnotes.modal-content{\r\n  height: 380px!important;\r\n}\r\n\r\n.svg_userrole {\r\n  font-size: 17px;\r\n  position: relative;\r\n  top: 3px;\r\n  width: auto;\r\n  left: -2px;\r\n  color: #307de1;\r\n}\r\n::ng-deep.Version_dropDown .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value{\r\n  width: 65% !important;\r\n}\r\n.Version_dropDown{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-block: 1%;\r\n  padding-left: 5px;\r\n}\r\n::ng-deep.Version_dropDown  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Version_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Version_dropDown .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Version_dropDown  .mat-select-trigger {\r\n  min-width: 8vw !important;\r\n}\r\n::ng-deep.Version_dropDown  .mat-select-arrow {\r\n  position: absolute !important;\r\n  right: 5% !important;\r\n}\r\n::ng-deep.mappingnote .modal-dialog {\r\n  max-width: 83% !important;\r\n  top: 10%!important;\r\n  max-height: 60% !important;\r\n  height: 52% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.mappingnote .modal-backdrop.show {\r\n  z-index: 1050 !important;\r\n}\r\n\r\n::ng-deep.mapping_method_auto .autocomplete-container .suggestions-container.is-visible{\r\n  z-index: 999 !important;\r\n  border-radius: 5px !important;\r\n  bottom: 100% !important;\r\n}\r\n\r\n.others_width{\r\n  width: 581px !important;\r\n  position: relative !important;\r\n}\r\n\r\n\r\n.primary_btn{\r\n  background-color: #673ab7 !important;\r\n  color: #fff !important;\r\n  letter-spacing: normal !important;\r\n    border-radius: 5pc;\r\n}\r\n.mapped_btn{\r\n  background-color: #05640d !important;\r\n  color: #fff !important;\r\n    border-radius: 5pc;\r\n    letter-spacing: normal !important;\r\n}\r\n::ng-deep.matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper{\r\n  padding-top: 0px !important;\r\n  padding-bottom: 0px !important;\r\n}\r\n\r\n::ng-deep body.xmlmappings-version-select-open\r\n  .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n  pointer-events: none !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-select-panel.xmlmappings-version-select-panel {\r\n  z-index: 10001 !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.cdk-drag-preview {\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\r\n              0 8px 10px 1px rgba(0, 0, 0, 0.14),\r\n              0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.cdk-drag-placeholder {\r\n  opacity: 0;\r\n}\r\n\r\n.cdk-drag-animating {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n\r\n// .example-box:last-child {\r\n//   border: none;\r\n// }\r\n\r\n// .example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\r\n//   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n// }\r\n.custom-drag-preview{\r\nz-index: 100000000000 !important;\r\nopacity: 0.9 !important;\r\nborder-radius: 5pc;\r\n}\r\n\r\n.xml-split-toggle {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  left: calc(50% - 12px);\r\n  background: #fff;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);\r\n  border-radius: 5%;\r\n  width: 20px;\r\n  height: 20px;\r\n  line-height: 36px;\r\n  background-color: #a9a9a9;\r\n\r\n  &.xml-split-toggle--edge {\r\n    left: 8px;\r\n  }\r\n\r\n  mat-icon {\r\n    right: 12px;\r\n    font-size: 22px;\r\n    position: relative;\r\n    bottom: 16px;\r\n    color: white;\r\n  }\r\n}\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
